import { render, staticRenderFns } from "./InfantClubIcon.vue?vue&type=template&id=0d7b4424&"
import script from "./InfantClubIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InfantClubIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports